module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero-container"
  }, [_c('div', {
    staticClass: "hero-content"
  }, [_c('h1', [_vm._v("Speical Thanks to")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.opendota.com/",
      "target": "_blank"
    }
  }, [_vm._v(" OpenDota API")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50d08081"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 139
// module chunks = 1